import moment from 'moment';

export default {
  data() {
    return {};
  },
  computed: {
    minDate() {
      return moment().format('YYYY-MM-DD');
    },
    minTime() {
      return moment().format('HH:mm');
    },
    startOfDay() {
      return moment().startOf('day').format('HH:mm');
    },
  },
  mounted() {},
  methods: {
    allowedStep: (m) => m % 30 === 0,
  },
};
